import { useCurrentInstance } from "@soft-db/soft-utils";
import { pointer } from "d3";
import { onMounted, onUnmounted, ref, type Ref } from "vue";
import type { SVGPosition } from "../interfaces";

export const useMousePosition = (rectRef: Ref<SVGGElement | undefined>) => {
	const instance = useCurrentInstance();
	const { emit } = instance;

	const position = ref<SVGPosition>({ x: 0, y: 0 });
	const inBounds = ref(false);

	const onMouseEnter = () => {
		inBounds.value = true;
	};

	const onMouseLeave = () => {
		inBounds.value = false;
	};

	const onMouseMove = (event: MouseEvent) => {
		const d3Position = pointer(event);
		position.value = { x: d3Position[0], y: d3Position[1] };
	};

	const onClick = (event: MouseEvent) => {
		const position = pointer(event);

		emit(event.type, { x: position[0], y: position[1] });
	};

	onMounted(() => {
		const rect = rectRef.value;
		if (!rect) return;

		rect.addEventListener("mouseenter", onMouseEnter);
		rect.addEventListener("mouseleave", onMouseLeave);
		rect.addEventListener("mousemove", onMouseMove);
		rect.addEventListener("click", onClick);
		rect.addEventListener("dblclick", onClick);
	});

	onUnmounted(() => {
		const rect = rectRef.value;
		if (!rect) return;

		rect.removeEventListener("mouseenter", onMouseEnter);
		rect.removeEventListener("mouseleave", onMouseLeave);
		rect.removeEventListener("mousemove", onMouseMove);
		rect.removeEventListener("click", onClick);
		rect.removeEventListener("dblclick", onClick);
	});

	return { position, inBounds };
};

export type SVGMouse = ReturnType<typeof useMousePosition>;
